import {
    GET_USAGER_SUCCESS,
    GET_USAGER_FAIL,
} from "./types";

import { ChequeCultureService } from "../../service/ChequeCultureService";

export const getUsagerInfo = () => (dispatch) => {
    const chequeCultureService = new ChequeCultureService();
    return chequeCultureService.getUsagerInfo().then(
        (response) => {
            localStorage.setItem("user", JSON.stringify(response.data));
            dispatch({
                type: GET_USAGER_SUCCESS,
                payload: { user: response.data },
            });
            return response.data;
        },
        (error) => {
            dispatch({
                type: GET_USAGER_FAIL,
            });
            return null;
        }
    );
};
